export const useStorage = () => {
  const storeId = "dune-london";

  const getStorage = (key: string) => storage.get(`${storeId}:${key}`);

  const setStorage = (key: string, value: any, expiryDays?: number) =>
    storage.set(`${storeId}:${key}`, value, expiryDays || undefined);

  const removeStorage = (key: string) => storage.remove(`${storeId}:${key}`);

  return { getStorage, setStorage, removeStorage };
};

export const storage = {
  get: (key: string) => {
    if (typeof window === "undefined") return null;
    const stored = localStorage.getItem(key);
    if (!stored) return null;

    try {
      const item = JSON.parse(stored);
      const now = new Date();

      if (item?.expiry && now.getTime() > item?.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item?.value;
    } catch (e) {
      return stored;
    }
  },
  set: (key: string, value: string, days = 0) => {
    const now = new Date();
    const expiry = days && now.getTime() + days * 86400000;

    const item = {
      value,
      expiry,
    };

    localStorage.setItem(key, JSON.stringify(item));
  },
  setAll: (items: StorageItem[]) => items.map((item) => storage.set(item?.key, item?.value)),
  remove: (key: string) => localStorage.removeItem(key),
  wipe: () => localStorage.clear(),
  all: () => {
    const output = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      const value = localStorage.getItem(key);
      output.push({ key, value });
    }
    return output;
  },
};

type StorageItem = {
  key: string;
  value: string;
};
